<template>
  <transition name="modal">
    <div class="modal-mask" style="display: block">
      <div class="modal-dialog modal modal-special" role="document">
        <div class="modal__content modal__content--lg">
          <div
            class="flex items-center px-5 py-5 sm:py-3 border-b border-gray-200"
          >
            <h2 class="font-medium text-base mr-auto">Crear Registro</h2>
          </div>
          <form
            @submit.prevent="createPlanning"
            enctype="multipart/form-data"
            class="form-planning"
          >
            <div class="p-5 grid grid-cols-12 gap-4 row-gap-3">
              <div class="col-span-12 sm:col-span-12">
                <label>Tarea</label>
                <input
                  type="text"
                  v-model="planning.task"
                  required
                  :class="`input w-full border mt-2 flex-1`"
                />
              </div>
              <div class="col-span-6 sm:col-span-6">
                <label>Cuenta</label>
                <select
                  class="input w-full border mt-2 flex-1"
                  v-model="planning.account_id"
                  required
                >
                  <option value="">Seleccione...</option>
                  <option
                    v-for="account in accounts"
                    :value="account.id"
                    :key="`account-${account.id}`"
                  >
                    {{ account.name }}
                  </option>
                </select>
              </div>
              <div class="col-span-6 sm:col-span-6">
                <label>Usuario</label>
                <select
                  class="input w-full border mt-2 flex-1"
                  v-model="planning.user_id"
                >
                  <option value="">Seleccione...</option>
                  <option
                    v-for="user in filteredUsers"
                    :value="user.id"
                    :key="`user-${user.id}`"
                  >
                    {{ user.name }}
                  </option>
                </select>
              </div>
              <div class="col-span-6 sm:col-span-6">
                <label>Horas</label>
                <input
                  type="number"
                  class="input w-full border mt-2 flex-1"
                  v-model="planning.hours"
                  required
                  step=".01"
                />
              </div>
              <div class="col-span-6 sm:col-span-6">
                <label>Fecha de entrega</label>
                <input
                  type="date"
                  class="input w-full border mt-2 flex-1"
                  v-model="planning.date"
                  required
                />
              </div>
            </div>
            <div class="px-5 py-3 text-right border-t border-gray-200">
              <button
                type="button"
                @click="$emit('closeModal')"
                class="button w-20 border text-gray-700 mr-1"
              >
                Cancelar
              </button>
              <button
                type="submit"
                class="button bg-theme-1 text-white"
                :class="
                  planningButtonLoading ? 'cursor-not-allowed opacity-50' : ''
                "
                :disabled="planningButtonLoading"
              >
                {{ planningButtonLoading ? 'Creando...' : 'Crear' }}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  props: ['team_session', 'accounts', 'users', 'planning_id'],
  data() {
    return {
      planning: this.definePlanning(),
      planningButtonLoading: false,
    }
  },
  created() {
    document.body.style.overflow = 'hidden'
  },
  beforeDestroy() {
    document.body.style.overflow = null
  },
  async beforeMount() {
    await Promise.all([this.getList('campaign'), this.getList('project')])
  },
  methods: {
    ...mapActions(['get', 'getList', 'post']),
    createPlanning() {
      this.planningButtonLoading = true
      this.planning.team_id = this.team_session
      this.planning.planning_id = this.planning_id
      console.log(this.planning)
      this.post(this.planning)
        .then((item) => {
          this.$emit('closeModal')
          this.$emit('planningCreated')
        })
        .catch((error) => {
          console.log('FAILURE!!')
        })
        .finally(() => {
          this.planningButtonLoading = false
        })
    },
    definePlanning() {
      return {
        entity: 'planning',
        task: '',
        hours: '',
        date: '',
        account_id: '',
        team_id: '',
        user_id: '',
        planning_id: null,
      }
    },
  },
  computed: {
    ...mapGetters({}),
    filteredUsers() {
      return this.users.filter((item) => {
        return this.team_session ? item.team_id == this.team_session : true
      })
    },
  },
}
</script>

<style>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-special {
  overflow: auto;

  background-image: initial;
  background-color: initial;

  margin-top: initial;
  margin-left: initial;
  background: none;
  transition: visibility 0s linear 0.2s, opacity 0.2s 0s;
  opacity: 1;
  width: 100vw;
  height: 100vh;
  position: fixed;
  left: 0;
  top: 0;

  visibility: visible;

  padding-top: 4rem;
}

.modal-special .modal__content {
  margin-top: auto;
}
</style>



// WEBPACK FOOTER //
// CreatePlanningModal.vue?cd295620